var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.getFlagSharedAgencyLoggedIn === true
      ? _c(
          "div",
          [
            _c("section", { attrs: { id: "content" } }, [
              _c("div", { staticClass: "container" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-9", attrs: { id: "main" } },
                    [
                      _c(
                        "div",
                        { staticClass: "container shortcode travel-ideas" },
                        [
                          _c("h1", { staticClass: "idea-title" }, [
                            _vm._m(0),
                            _vm._v(_vm._s(_vm.titleinfo[_vm.getCurrentLocale])),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _vm.get_shared_AgencyGetBookings.length === 0
                        ? _c(
                            "div",
                            { staticClass: "sdr-box booking-information" },
                            [
                              _c("h3", { staticClass: "skin-color" }, [
                                _vm._v(
                                  _vm._s(_vm.stillempty[_vm.getCurrentLocale])
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.get_shared_AgencyGetBookings.length > 0
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "search-tab-content sdr-box booking-information",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "tab-pane fade  active in",
                                  attrs: { id: "online-checkin-tab" },
                                },
                                [
                                  _c(
                                    "form",
                                    {
                                      on: {
                                        submit: function ($event) {
                                          $event.preventDefault()
                                          return _vm.onSubmit_FilterSearch(
                                            $event
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-xs-6 col-md-3" },
                                          [
                                            _c("h4", { staticClass: "title" }, [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.when[_vm.getCurrentLocale]
                                                )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "form-group" },
                                              [
                                                _c("label", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.flightdatefilter[
                                                        _vm.getCurrentLocale
                                                      ]
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("vue-pikaday", {
                                                  staticClass:
                                                    "input-text full-width",
                                                  attrs: {
                                                    name: "searchfor_flightdate",
                                                    placeholder: "",
                                                    options:
                                                      _vm.options[
                                                        _vm.getCurrentLocale
                                                      ],
                                                    value: _vm.start,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.searchfor_flightdate,
                                                    callback: function ($$v) {
                                                      _vm.searchfor_flightdate =
                                                        $$v
                                                    },
                                                    expression:
                                                      "searchfor_flightdate",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "col-md-6" }, [
                                          _c("h4", { staticClass: "title" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.what[_vm.getCurrentLocale]
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "form-group row" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "col-xs-4" },
                                                [
                                                  _c("label", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.bookingcodefilter[
                                                          _vm.getCurrentLocale
                                                        ]
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.searchfor_bookingcode,
                                                        expression:
                                                          "searchfor_bookingcode",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "input-text full-width",
                                                    attrs: {
                                                      type: "text",
                                                      placeholder:
                                                        "e.g. Q3KEEU89",
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.searchfor_bookingcode,
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.searchfor_bookingcode =
                                                          $event.target.value
                                                      },
                                                    },
                                                  }),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "col-xs-4" },
                                                [
                                                  _c("label", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.invoiceidfilter[
                                                          _vm.getCurrentLocale
                                                        ]
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.searchfor_invoiceid,
                                                        expression:
                                                          "searchfor_invoiceid",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "input-text full-width",
                                                    attrs: {
                                                      type: "text",
                                                      placeholder:
                                                        "e.g. 747978",
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.searchfor_invoiceid,
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.searchfor_invoiceid =
                                                          $event.target.value
                                                      },
                                                    },
                                                  }),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "col-xs-4" },
                                                [
                                                  _c("label", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.surnamefilter[
                                                          _vm.getCurrentLocale
                                                        ]
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.searchfor_surname,
                                                        expression:
                                                          "searchfor_surname",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "input-text full-width",
                                                    attrs: {
                                                      type: "text",
                                                      placeholder:
                                                        "e.g. Ibrahimi",
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.searchfor_surname,
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.searchfor_surname =
                                                          $event.target.value
                                                      },
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "form-group col-md-3 fixheight",
                                          },
                                          [
                                            _c(
                                              "label",
                                              { staticClass: "hidden-xs" },
                                              [_vm._v(" ")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "icon-check full-width",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.filterbookings[
                                                      _vm.getCurrentLocale
                                                    ]
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.get_shared_AgencyGetBookings.length > 0
                        ? _c(
                            "button",
                            {
                              staticClass: "btn-large full-width totalbutton",
                              staticStyle: {
                                cursor: "initial",
                                outline: "none !important",
                                "outline-style": "none !important",
                                "margin-bottom": "15px",
                                background: "#3bdd4e",
                                "font-size": "1.4em",
                                height: "65px",
                              },
                              attrs: { type: "button" },
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.totalagencyprice[_vm.getCurrentLocale]
                                  ) +
                                  ": " +
                                  _vm._s(
                                    _vm._f("rndAmntRUAFWZ")(
                                      Number(
                                        _vm.get_shared_AgencyAgencyTotalBrutto
                                      )
                                    )
                                  ) +
                                  ",  " +
                                  _vm._s(
                                    _vm.totalcustomerprice[_vm.getCurrentLocale]
                                  ) +
                                  ": " +
                                  _vm._s(
                                    _vm._f("rndAmntRUAFWZ")(
                                      Number(_vm.get_shared_AgencyTotalBrutto)
                                    )
                                  ) +
                                  "\n                            "
                              ),
                              _c("br"),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticStyle: { "font-size": "0.5em" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.tincludedtaxes[_vm.getCurrentLocale]
                                    )
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.get_shared_AgencyGetBookings.length > 0
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                "text-align": "end",
                                "font-size": "1.0rem",
                                "font-weight": "700",
                                "margin-bottom": "20px",
                                color: "rgb(0, 160, 19)",
                              },
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.freecashlimit[_vm.getCurrentLocale]
                                  ) +
                                  ": " +
                                  _vm._s(
                                    _vm._f("rndAmntRUAFWZ")(
                                      Number(
                                        _vm.get_shared_AgencyAgencyCashLimit
                                      )
                                    )
                                  ) +
                                  "\n                        "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.get_shared_AgencyGetBookings.length > 0
                        ? _c(
                            "button",
                            {
                              staticClass: "btn-large full-width totalbutton",
                              staticStyle: {
                                cursor: "initial",
                                outline: "none !important",
                                "outline-style": "none !important",
                                "margin-bottom": "30px",
                                background: "#00a013",
                                "font-size": "1.4em",
                                height: "35px",
                              },
                              attrs: { type: "button" },
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: { href: "#" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      _vm.onClick_ExcelDownload(_vm.booking)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "xskin-color",
                                      staticStyle: {
                                        "font-size": "1.0625em",
                                        width: "100%",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.downloadexcel[
                                            _vm.getCurrentLocale
                                          ]
                                        ) + " ⤋"
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.get_shared_AgencyGetBookings.length > 0
                        ? _c(
                            "div",
                            { staticClass: "sdr-box booking-information" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "tab-pane",
                                  attrs: { id: "booking" },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "booking-history" },
                                    _vm._l(
                                      _vm.get_shared_AgencyGetBookings_Filtered,
                                      function (booking, index) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            staticClass:
                                              "booking-info clearfix",
                                          },
                                          [
                                            _c("div", { staticClass: "date" }, [
                                              _c(
                                                "label",
                                                { staticClass: "month" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("monthname")(
                                                        booking.addendum
                                                          .bookingDate
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "label",
                                                { staticClass: "date" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("dayofmonth")(
                                                        booking.addendum
                                                          .bookingDate
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "label",
                                                { staticClass: "day" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("weekday")(
                                                        booking.addendum
                                                          .bookingDate
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "h5",
                                              { staticClass: "box-title" },
                                              [
                                                _vm.get_BookedOrPartialOrFull(
                                                  booking
                                                ) === "fullybooked"
                                                  ? _c("i", {
                                                      staticClass:
                                                        "icon soap-icon-plane-right takeoff-effect circle",
                                                      staticStyle: {
                                                        color: "#3bdd4e",
                                                      },
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.get_BookedOrPartialOrFull(
                                                  booking
                                                ) === "partialcancelled"
                                                  ? _c("i", {
                                                      staticClass:
                                                        "icon soap-icon-plane-right takeoff-effect circle",
                                                      staticStyle: {
                                                        color: "#ffd60a",
                                                      },
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.get_BookedOrPartialOrFull(
                                                  booking
                                                ) === "fullycancelled"
                                                  ? _c("i", {
                                                      staticClass:
                                                        "icon soap-icon-plane-right takeoff-effect circle",
                                                      staticStyle: {
                                                        color: "#E74C3C",
                                                      },
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.get_BookedOrPartialOrFull(
                                                  booking
                                                ) === "fullybooked"
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          "font-weight": "600",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.agenturprice[
                                                              _vm
                                                                .getCurrentLocale
                                                            ]
                                                          ) +
                                                            ": " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "rndAmntRUAFWZ"
                                                              )(
                                                                Number(
                                                                  booking
                                                                    .addendum
                                                                    .agencyPrice
                                                                )
                                                              )
                                                            ) +
                                                            "; " +
                                                            _vm._s(
                                                              _vm
                                                                .agenturcommission[
                                                                _vm
                                                                  .getCurrentLocale
                                                              ]
                                                            ) +
                                                            ": " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "rndAmntRUAFWZ"
                                                              )(
                                                                Number(
                                                                  booking
                                                                    .addendum
                                                                    .agencyCommission
                                                                )
                                                              )
                                                            ) +
                                                            "; " +
                                                            _vm._s(
                                                              _vm.customerprice[
                                                                _vm
                                                                  .getCurrentLocale
                                                              ]
                                                            ) +
                                                            ": " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "rndAmntRUAFWZ"
                                                              )(
                                                                Number(
                                                                  booking
                                                                    .addendum
                                                                    .bruttoTotal
                                                                )
                                                              )
                                                            )
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.get_BookedOrPartialOrFull(
                                                  booking
                                                ) !== "fullybooked"
                                                  ? _c("span", [_vm._v("-")])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _c(
                                                    "small",
                                                    {
                                                      staticStyle: {
                                                        "padding-left": "37px",
                                                        width: "400px",
                                                      },
                                                    },
                                                    [
                                                      _vm.get_BookedOrPartialOrFull(
                                                        booking
                                                      ) === "fullybooked"
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                color:
                                                                  "#3bdd4e",
                                                                "text-transform":
                                                                  "uppercase",
                                                                "font-weight":
                                                                  "600",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .fullybooked[
                                                                    _vm
                                                                      .getCurrentLocale
                                                                  ]
                                                                ) +
                                                                  _vm._s(
                                                                    booking
                                                                      .addendum
                                                                      .rebookingInvoice ===
                                                                      true
                                                                      ? " " +
                                                                          _vm
                                                                            .rebookingumbuchung[
                                                                            _vm
                                                                              .getCurrentLocale
                                                                          ]
                                                                      : ""
                                                                  ) +
                                                                  "; "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm.get_BookedOrPartialOrFull(
                                                        booking
                                                      ) === "partialcancelled"
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                color:
                                                                  "#ffd60a",
                                                                "text-transform":
                                                                  "uppercase",
                                                                "font-weight":
                                                                  "600",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .partialcancelled[
                                                                    _vm
                                                                      .getCurrentLocale
                                                                  ]
                                                                ) +
                                                                  _vm._s(
                                                                    booking
                                                                      .addendum
                                                                      .rebookingInvoice ===
                                                                      true
                                                                      ? " " +
                                                                          _vm
                                                                            .rebookingumbuchung[
                                                                            _vm
                                                                              .getCurrentLocale
                                                                          ]
                                                                      : ""
                                                                  ) +
                                                                  "; "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm.get_BookedOrPartialOrFull(
                                                        booking
                                                      ) === "fullycancelled"
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                color:
                                                                  "#E74C3C",
                                                                "text-transform":
                                                                  "uppercase",
                                                                "font-weight":
                                                                  "600",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .fullycancelled[
                                                                    _vm
                                                                      .getCurrentLocale
                                                                  ]
                                                                ) +
                                                                  _vm._s(
                                                                    booking
                                                                      .addendum
                                                                      .rebookingInvoice ===
                                                                      true
                                                                      ? " " +
                                                                          _vm
                                                                            .rebookingumbuchung[
                                                                            _vm
                                                                              .getCurrentLocale
                                                                          ]
                                                                      : ""
                                                                  ) +
                                                                  "; "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.passengers[
                                                              _vm
                                                                .getCurrentLocale
                                                            ]
                                                          ) + ":"
                                                        ),
                                                      ]),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.get_ListOfPassengers(
                                                              booking
                                                            )
                                                          ) +
                                                          "\n                                                "
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("dl", { staticClass: "info" }, [
                                              _c("dt", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.invoiceid[
                                                      _vm.getCurrentLocale
                                                    ]
                                                  )
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("dd", [
                                                _vm._v(
                                                  _vm._s(
                                                    booking.addendum.idInvoice
                                                      ? booking.addendum
                                                          .idInvoice
                                                      : "-"
                                                  ) + " "
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("dt", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.bookingno[
                                                      _vm.getCurrentLocale
                                                    ]
                                                  )
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("dd", [
                                                _vm._v(
                                                  _vm._s(
                                                    booking.addendum.bookingNo
                                                  )
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "dd",
                                                {
                                                  staticStyle: {
                                                    "margin-top": "5px",
                                                    "font-weight": "700",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.get_RouteOfBooking(
                                                        booking
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "button",
                                              {
                                                staticClass: "btn-mini status",
                                                staticStyle: {
                                                  background: "#3bdd4e",
                                                  width: "110px",
                                                },
                                                attrs: {
                                                  title: ".pdf Download",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    _vm.onClick_PdfDownload(
                                                      booking
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.downloadpdf[
                                                      _vm.getCurrentLocale
                                                    ]
                                                  ) + " ⤋"
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "button",
                                              {
                                                staticClass: "btn-mini status",
                                                staticStyle: {
                                                  background: "rgb(0, 160, 19)",
                                                  width: "110px",
                                                  "margin-top": "5px",
                                                },
                                                attrs: {
                                                  title: ".pdf Download",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    _vm.onClick_InvoiceDownload(
                                                      booking
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.downloadinvoice[
                                                      _vm.getCurrentLocale
                                                    ]
                                                  ) + " ⤋"
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      }
                                    )
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.get_shared_AgencyGetBookings.length > 0
                        ? _c(
                            "button",
                            {
                              staticClass: "btn-large full-width totalbutton",
                              staticStyle: {
                                cursor: "initial",
                                outline: "none !important",
                                "outline-style": "none !important",
                                "margin-bottom": "15px",
                                background: "#00a013",
                                "font-size": "1.4em",
                                height: "35px",
                              },
                              attrs: { type: "button" },
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: { href: "#" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      _vm.onClick_ExcelDownload(_vm.booking)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "xskin-color",
                                      staticStyle: {
                                        "font-size": "1.0625em",
                                        width: "100%",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.downloadexcel[
                                            _vm.getCurrentLocale
                                          ]
                                        ) + " ⤋"
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.get_shared_AgencyGetBookings.length > 0
                        ? _c(
                            "button",
                            {
                              staticClass: "btn-large full-width totalbutton",
                              staticStyle: {
                                cursor: "initial",
                                outline: "none !important",
                                "outline-style": "none !important",
                                "margin-bottom": "15px",
                                background: "#3bdd4e",
                                "font-size": "1.4em",
                                height: "65px",
                              },
                              attrs: { type: "button" },
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.totalagencyprice[_vm.getCurrentLocale]
                                  ) +
                                  ": " +
                                  _vm._s(
                                    _vm._f("rndAmntRUAFWZ")(
                                      Number(
                                        _vm.get_shared_AgencyAgencyTotalBrutto
                                      )
                                    )
                                  ) +
                                  ",  " +
                                  _vm._s(
                                    _vm.totalcustomerprice[_vm.getCurrentLocale]
                                  ) +
                                  ": " +
                                  _vm._s(
                                    _vm._f("rndAmntRUAFWZ")(
                                      Number(_vm.get_shared_AgencyTotalBrutto)
                                    )
                                  ) +
                                  "\n                            "
                              ),
                              _c("br"),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticStyle: { "font-size": "0.5em" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.tincludedtaxes[_vm.getCurrentLocale]
                                    )
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "sidebar col-sms-6 col-sm-4 col-md-3 topDistance",
                    },
                    [
                      _c("h4", { staticClass: "search-results-title" }, [
                        _c("i", { staticClass: "soap-icon-search" }),
                        _c("b", [
                          _vm._v(
                            _vm._s(_vm.get_shared_AgencyGetBookings.length)
                          ),
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(_vm.resultsshown[_vm.getCurrentLocale]) +
                            ".\n                        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("sdr-modifysearch-box"),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("sdr-contact-box"),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("sdr-promobox"),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.getFlagSharedAgencyLoggedIn === false
      ? _c(
          "div",
          [
            _c("section", { attrs: { id: "content" } }, [
              _c("div", { staticClass: "container" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-9", attrs: { id: "main" } },
                    [
                      _c(
                        "div",
                        { staticClass: "container shortcode travel-ideas" },
                        [
                          _c(
                            "h1",
                            {
                              staticClass: "idea-title",
                              staticStyle: { color: "red" },
                            },
                            [
                              _vm._m(1),
                              _vm._v(
                                _vm._s(
                                  _vm.titleinfo_loggedout[_vm.getCurrentLocale]
                                )
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "sidebar col-md-3" },
                    [_c("sdr-contact-box")],
                    1
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("sdr-promobox"),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "index" }, [
      _c("i", {
        staticClass: "soap-icon-star circle",
        staticStyle: { background: "#3bdd4e" },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "index" }, [
      _c("i", { staticClass: "soap-icon-star circle" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }